/** Public site origin for sticker QR links (set in production). */
export function getPublicSiteOrigin() {
  const env = (process.env.REACT_APP_PUBLIC_SITE_URL || '').trim().replace(/\/$/, '');
  if (env) return env;
  if (typeof window !== 'undefined') return window.location.origin;
  return '';
}

export function buildPackageTrackUrl(packageCode) {
  const code = String(packageCode || '').trim();
  const base = getPublicSiteOrigin();
  if (!code || !base) return '';
  return `${base}/track-package?p=${encodeURIComponent(code.toUpperCase())}`;
}

export function parsePackageCodeFromScan(raw) {
  const s = String(raw || '').trim();
  if (!s) return '';
  try {
    const url = new URL(s);
    const p = url.searchParams.get('p');
    if (p) return p.trim().toUpperCase();
  } catch {
    /* plain code, not a URL */
  }
  return s.toUpperCase();
}

/** Package / HBL tracking stages — Malaysia → Sri Lanka delivery flow */
export const TRACKING_STATUS_OPTIONS = [
  { value: 'collected', label: 'Collected', defaultLocation: 'Malaysia' },
  { value: 'malaysia-warehouse', label: 'Received at Malaysia warehouse', defaultLocation: 'Malaysia warehouse' },
  { value: 'export-clearance', label: 'Cleared for export', defaultLocation: 'Malaysia' },
  { value: 'loading', label: 'Loading', defaultLocation: 'Malaysia' },
  { value: 'malaysia-port', label: 'At Malaysia port', defaultLocation: 'Malaysia port' },
  { value: 'shipped', label: 'Shipped', defaultLocation: 'In transit' },
  { value: 'sri-lanka-port', label: 'At Sri Lanka port', defaultLocation: 'Sri Lanka port' },
  { value: 'sri-lanka-warehouse', label: 'At Sri Lanka warehouse', defaultLocation: 'Sri Lanka warehouse' },
  { value: 'customs-in-progress', label: 'Customs clearance in progress', defaultLocation: 'Sri Lanka' },
  { value: 'customs-cleared', label: 'Customs clearance completed', defaultLocation: 'Sri Lanka' },
  { value: 'delivery-hub', label: 'At delivery hub', defaultLocation: 'Sri Lanka delivery hub' },
  { value: 'out-for-delivery', label: 'Out for delivery', defaultLocation: 'Sri Lanka' },
  { value: 'delivered', label: 'Delivered', defaultLocation: 'Sri Lanka' },
];

const LEGACY_STATUS_LABELS = {
  'received-at-warehouse': 'Received at warehouse',
  sorted: 'Sorted',
  loaded: 'Loaded',
  'in-transit': 'In transit',
};

export const PACKAGE_STATUS_LABELS = Object.fromEntries(
  TRACKING_STATUS_OPTIONS.map((s) => [s.value, s.label])
);

Object.assign(PACKAGE_STATUS_LABELS, LEGACY_STATUS_LABELS);

export function packageStatusLabel(s) {
  return PACKAGE_STATUS_LABELS[s] || String(s || '—').replace(/-/g, ' ');
}

export function defaultLocationForStatus(status) {
  const opt = TRACKING_STATUS_OPTIONS.find((s) => s.value === status);
  return opt?.defaultLocation || '';
}
